import type { GeoSpaceChiban, PropertySelectionRow } from "../../types";
import { normalizeChibanKaokuNumber, normalizeLocation } from "../index";

/**
 * 物件一覧の土地の行に、引いた地番の情報のポリゴンを付ける。
 * 都道府県・所在・地番が同じで、まだポリゴンを持たない行だけが対象。
 * 不動産検索の結果から入れた行は地番の形を持たないので、あとから引いた地番の情報で補い、
 * 地図クリックで入れた行と同じく地図に範囲を描けるようにする
 *
 * @param location 地番の情報の所在（市区町村・大字・字をつないだもの）
 * @returns 付けた行があれば新しい配列、無ければ rows をそのまま返す
 */
export const attachParcelPolygon = (
  rows: PropertySelectionRow[],
  parcel: GeoSpaceChiban,
  location: string
): PropertySelectionRow[] => {
  const polygon = parcel.polygon;
  if (!polygon?.coordinates?.length) return rows;

  const normalizedLocation = normalizeLocation(location);
  const chiban = normalizeChibanKaokuNumber(parcel.chiban);
  let attached = false;
  const nextRows = rows.map((row) => {
    if (
      row.bookType !== "LAND" ||
      row.prefName !== parcel.prefName ||
      normalizeLocation(row.location) !== normalizedLocation ||
      normalizeChibanKaokuNumber(row.chibanKaokuNumber) !== chiban ||
      !row.rawData ||
      row.rawData.polygon?.coordinates?.length
    ) {
      return row;
    }
    attached = true;
    return { ...row, rawData: { ...row.rawData, polygon } };
  });
  return attached ? nextRows : rows;
};
